import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1 style={styles.title}>Privacy Policy</h1>
      </div>

      <div style={styles.content}>
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Information We Collect</h2>
          <p style={styles.text}>
            We collect the following information to provide and improve our Service:
          </p>
          <ul style={styles.list}>
            <li><strong>Account Information:</strong> Email address and password (encrypted)</li>
            <li><strong>Usage Data:</strong> Traffic usage, connection times, and service status</li>
            <li><strong>Technical Data:</strong> IP address, device type, and connection logs</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>2. How We Use Your Information</h2>
          <p style={styles.text}>
            We use collected information for the following purposes:
          </p>
          <ul style={styles.list}>
            <li>Provide and maintain the VPN service</li>
            <li>Monitor service usage and enforce quota limits</li>
            <li>Send important service notifications</li>
            <li>Improve service quality and user experience</li>
            <li>Prevent fraud and abuse</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Data Storage and Security</h2>
          <p style={styles.text}>
            We take data security seriously:
          </p>
          <ul style={styles.list}>
            <li>All passwords are encrypted using industry-standard hashing</li>
            <li>Data is stored on secure AWS infrastructure</li>
            <li>We use HTTPS/TLS encryption for all communications</li>
            <li>Access to user data is strictly limited</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Data Sharing</h2>
          <p style={styles.text}>
            We do not sell, trade, or rent your personal information to third parties. We may share data only in the following circumstances:
          </p>
          <ul style={styles.list}>
            <li>With your explicit consent</li>
            <li>To comply with legal obligations or court orders</li>
            <li>To protect our rights, property, or safety</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Data Retention</h2>
          <p style={styles.text}>
            We retain your data for as long as your account is active. Connection logs are automatically deleted after 30 days. You may request account deletion at any time by contacting us.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Your Rights</h2>
          <p style={styles.text}>
            You have the right to:
          </p>
          <ul style={styles.list}>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and data</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Cookies and Tracking</h2>
          <p style={styles.text}>
            We use minimal cookies for authentication and session management. We do not use third-party tracking or advertising cookies.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Children's Privacy</h2>
          <p style={styles.text}>
            Our Service is not intended for users under 18 years of age. We do not knowingly collect information from children.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Changes to This Policy</h2>
          <p style={styles.text}>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>10. Contact Us</h2>
          <p style={styles.text}>
            If you have any questions about this Privacy Policy, please contact:<br />
            Email: douxingma@zohomail.com<br />
            Location: Washington State, USA
          </p>
        </section>

        <p style={styles.updateTime}>Last Updated: April 23, 2026</p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    background: '#f5f7fa',
    padding: '20px'
  },
  header: {
    maxWidth: '800px',
    margin: '0 auto 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  backBtn: {
    padding: '10px 20px',
    background: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#666'
  },
  title: {
    margin: 0,
    color: '#333',
    fontSize: '28px',
    fontWeight: 'bold'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    background: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
  },
  section: {
    marginBottom: '32px'
  },
  sectionTitle: {
    color: '#333',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '16px'
  },
  text: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.8',
    margin: '0 0 12px 0'
  },
  list: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.8',
    paddingLeft: '24px'
  },
  updateTime: {
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #f0f0f0',
    color: '#999',
    fontSize: '14px',
    textAlign: 'center'
  }
};
